"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
exports.JsonPathFormGroup = (_a) => {
    var { onChange, label, value } = _a, props = tslib_1.__rest(_a, ["onChange", "label", "value"]);
    return (react_1.default.createElement(reactstrap_1.FormGroup, null,
        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, label),
        react_1.default.createElement(reactstrap_1.InputGroup, null,
            react_1.default.createElement(reactstrap_1.Input, Object.assign({ placeholder: "$", className: "text-monospace" }, props, { value: value || '', onChange: ({ target: { value } }) => {
                    onChange(value);
                } })))));
};
//# sourceMappingURL=JsonPathFormGroup.js.map